export const downloadAndSave = async (fetchPromise: Promise<Response>, defaultFilename: string) => {
  try {
    const data = await fetchPromise
    const blob = await data.blob()

    const contentDisposition = data.headers.get('Content-Disposition')
    const match = contentDisposition?.match(/filename="(.+?)"/)
    const filename = match ? decodeURIComponent(match[1]) : defaultFilename

    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = filename
    link.click()
    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error('Download failed:', error)
    throw error
  }
}

export const sortItems = <T>(items: T[], sortState: { column: string; direction: string }): T[] => {
  return [...items].sort((a, b) => {
    const col = sortState.column
    const dir = sortState.direction === 'asc' ? 1 : -1

    let aVal = a[col]
    let bVal = b[col]

    if (aVal instanceof Date) aVal = aVal.getTime()
    if (bVal instanceof Date) bVal = bVal.getTime()
    if (typeof aVal === 'string') aVal = aVal.toLowerCase()
    if (typeof bVal === 'string') bVal = bVal.toLowerCase()

    return aVal > bVal ? dir : aVal < bVal ? -dir : 0
  })
}
export const mimeToIconMap: Record<string, string> = {
  // Office Docs
  'application/msword': 'DocTypeDefault',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DocxTypeDefault',
  'application/vnd.ms-excel': 'XlsTypeDefault',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XlsxTypeDefault',
  'application/vnd.ms-powerpoint': 'PptTypeDefault',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PptxTypeDefault',

  // Text & Code
  'text/plain': 'TxtTypeDefault',
  'application/json': 'JsonTypeDefault',
  'text/csv': 'CsvTypeDefault',

  // Images
  'image/png': 'ImageTypeDefault',
  'image/jpeg': 'ImageTypeDefault',
  'image/jpg': 'ImageTypeDefault',
  'image/webp': 'ImageTypeDefault',
  'image/svg+xml': 'ImageTypeDefault',
  'image/gif': 'ImageTypeDefault',

  // Aliases (if needed)
  'image/img': 'ImgTypeDefault', // fallback alias

  // Audio
  'audio/mpeg': 'Mp3TypeDefault',
  'audio/wav': 'WavTypeDefault',

  // Video
  'video/mp4': 'Mp4TypeDefault',

  // Design files
  'application/vnd.adobe.photoshop': 'PsdPhotoshopTypeDefault',
  'image/vnd.adobe.photoshop': 'PsdPhotoshopTypeDefault',
  'application/vnd.adobe.illustrator': 'AiIllustratorTypeDefault',
  'application/x-figma': 'FigFigmaTypeDefault',

  // Compressed archives
  'application/zip': 'ZipTypeDefault',
  'application/x-rar-compressed': 'RarTypeDefault',

  // PDF
  'application/pdf': 'PdfTypeDefault',

  // Generic fallback
  'application/octet-stream': 'EmptyTypeDefault',
}
